import { SET_LOCALE_LNG } from "../constants/actionTypes";

const DEFAULT_LNG = "fr";

const initialState = {
  lng: DEFAULT_LNG
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LOCALE_LNG:
      return {
        lng: action.payload.lng
      };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/locale.js